var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3132:26570)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.82 5.41C15.67 5.26 15.4801 5.16 15.2701 5.13L10.87 4.49L8.89005 0.53C8.73005 0.21 8.40005 0.02 8.06005 0C8.05005 0 8.05005 0 8.04005 0H8.03005C7.69005 0.02 7.36005 0.21 7.20005 0.53L5.23005 4.5L0.830049 5.14C0.620049 5.17 0.430049 5.27 0.280049 5.42C-0.0999507 5.79 -0.0899507 6.4 0.290049 6.77L3.47005 9.86L2.72005 14.22C2.68005 14.43 2.72005 14.64 2.82005 14.83C3.07005 15.3 3.65005 15.48 4.12005 15.23L8.04005 13.18L11.96 15.23C12.43 15.48 13.01 15.3 13.26 14.83C13.36 14.64 13.39 14.43 13.36 14.22L12.61 9.86L15.79 6.77C16.18 6.4 16.19 5.79 15.82 5.41Z",
    fill: "#6C757D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3132:26570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.09,
    height: 15.33,
    fill: "white"
  })))));
}

export default SvgStar;